// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../../duck';
import VerificationModal from '../component/VerificationModal';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    isVerifying: state.authModals.isVerifying,
    verificationError: state.authModals.verificationError,
    isResending: state.authModals.isResending,
    resendError: state.authModals.resendError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerificationModal);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/verification-modal/container/VerificationModalContainer.js